import { keyBy } from "lodash";

import { Action } from "../../store/types";
import { Portfolio, PortfolioCategory } from "../../models";
import * as actions from "./actions";

export interface PortfolioState {
  portfolios: { [id: number]: Portfolio };
  categories: { [id: number]: PortfolioCategory };
  chosenCategory: number;
}

const initState: PortfolioState = {
  portfolios: {},
  categories: {},
  chosenCategory: 0,
};

export default function(
  state = initState,
  { type, payload }: Action,
): PortfolioState {
  switch (type) {
    case actions.SET_PORTFOLIOS:
      return {
        ...state,
        portfolios: keyBy<Portfolio>(payload, portfolio => portfolio.id),
      };
    case actions.SET_CATEGORIES:
      return {
        ...state,
        categories: keyBy<PortfolioCategory>(payload, category => category.id),
      };
    case actions.SET_CHOSEN_CATEGORY:
      return {
        ...state,
        chosenCategory: payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/PortfolioCarousel/reducer.ts